export enum AuthorizationTypeEnum {
  Code = 'CODE',
  Token = 'TOKEN',
}
